const navbar = document.querySelectorAll('.navbar');
const navbar_ddtoggle = document.querySelectorAll('.navbar .dropdown-toggle');
const body = document.body;

navbar.forEach(function (element) {
    element.addEventListener('hide.bs.collapse', function () {
        body.classList.remove('navigation-active');
    })
    element.addEventListener('show.bs.collapse', function () {
        setTimeout(() => {
            body.classList.add('navigation-active');
        }, 0)
    })
})


const dropdown = document.querySelectorAll('.dropdown-toggle');

dropdown.forEach(function (element) {
    element.addEventListener('hide.bs.dropdown', function () {
        element.parentElement.classList.remove('dropdown-active');
    })
    element.addEventListener('show.bs.dropdown', function () {
        element.parentElement.classList.add('dropdown-active');
    })
})


const accordion = document.querySelectorAll('.accordion-collapse');

accordion.forEach(function (element) {
    element.addEventListener('hide.bs.collapse', function () {
        element.parentElement.classList.remove('accordion-item-active');
    })
    element.addEventListener('show.bs.collapse', function () {
        element.parentElement.classList.add('accordion-item-active');
    })
})

/* linked dd toggles on desktop */
if (window.matchMedia('(min-width: 1200px)').matches) {
    navbar_ddtoggle.forEach(function (element) {
        element.addEventListener("click", function() {
            location.href = element.href;
        });
    });

}
